/**
 * Created by Jew on 5/25/2017.
 */
import { Component, OnInit } from '@angular/core';

@Component({
   selector: 'app-privacy',
   templateUrl: './privacy.component.html',
   styleUrls: ['./privacy.component.css'],
})
export class PrivacyComponent implements OnInit {
   lang: string;

   ngOnInit(): void {
      this.lang = localStorage.getItem('lang') || 'en';
      setTimeout(() => {
         window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 100);
   }
}
